// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Vue from "vue";
import VueI18n from "vue-i18n";
import { storage } from "@/utils/storage";
import { ACTIVE_LANG } from "@/utils/storageKey";

// 导入语言包信息
import en from "./locale/en.json";
import es from "./locale/es.json";
import pt from "./locale/pt.json";
import zh from "./locale/zh-CN.json";
import id from "./locale/id.json";
import th from "./locale/th.json";

// element-ui lang
import locale from "element-ui/lib/locale";
import enLocale from "element-ui/lib/locale/lang/en";
import ptLocale from "element-ui/lib/locale/lang/pt";
import esLocale from "element-ui/lib/locale/lang/es";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import idLocale from "element-ui/lib/locale/lang/id";
import thLocale from "element-ui/lib/locale/lang/th";

// 注册i18n
Vue.use(VueI18n);

const messages = {
  'en-US': {
    ...en,
    ...enLocale,
  },
  'pt-PT': {
    ...pt,
    ...ptLocale,
  },
  'es-ES': {
    ...es,
    ...esLocale,
  },
  'zh-CN': {
    ...zh,
    ...zhLocale,
  },
  'id-ID': {
    ...id,
    ...idLocale,
  },
  'th-TH': {
    ...th,
    ...thLocale,
  },
};

// 默认语言优先级: 本地缓存语言优先, 系统语言次之, app打包时的默认语言再次之
let NAVIGATOR_LANG = (navigator.language || navigator.userLanguage);

!(window as any).langs.includes(NAVIGATOR_LANG) && (NAVIGATOR_LANG = null);
export const defaultLocal = storage.get(ACTIVE_LANG) || NAVIGATOR_LANG || window.defaultLang || "en-US";

// 通过选项创建 VueI18n 实例并导出
const i18n = new VueI18n({
  locale: defaultLocal, // 设置当前语言环境，默认中文简体
  messages, // 设置语言环境对应信息
});

// 切换语言的方法
export function changeLocale(lang: string): void {
  i18n.locale = lang;
  storage.set(ACTIVE_LANG, lang);
  document.querySelector("html")?.setAttribute("lang", lang);
}

locale.i18n((key, value) => i18n.t(key, value));

export default i18n;
